export const SET_LANGUAGE = "Language/SET_LANGUAGE";
